<style lang="scss" scoped>
@import '$vars';

.medical-history-section {
  @apply flex flex-col items-center content-start justify-start;
  @apply w-full;
  margin-bottom: 2px;

  &__header {
    @apply flex flex-row items-center justify-between;
    @apply w-full p-2;
    @apply cursor-pointer;
    background: rgb(236, 240, 241);
  }

  &__title {
    @apply m-0 p-0;
    @apply text-grayDark;
    font-family: $font1;
    font-size: 0.8rem;
    font-weight: 600;
  }

  &__content {
    @apply w-full p-2;
  }

  &__icon {
    transition: all 0.3s ease;

    &--up {
      transform: rotate(180deg);
      transition: all 0.3s ease;
    }
  }
}

.history-notes {
  @apply w-full flex flex-col items-start justify-start;

  &__wrapper {
    @apply w-full flex flex-col items-start justify-start;
  }

  &__text {
    @apply w-full border;
  }

  &__btn {
    @apply my-2 ml-auto;
  }

  &__note {
    @apply flex flex-col items-start content-start justify-start w-full;
    @apply pb-1 mb-2;
    border-bottom: 1px solid rgb(225, 225, 225);

    &-text {
      @apply w-full m-0 p-0;
      font-size: 0.75rem;
    }

    &-footer {
      @apply flex flex-row items-start justify-end w-full;
      font-size: 0.6rem;
      font-weight: 600;
    }
  }
}
</style>

<template>
  <section class="medical-history-section">
    <header
      class="medical-history-section__header"
      @click="ui.isOpen = !ui.isOpen"
    >
      <h2 class="medical-history-section__title">
        Notas
      </h2>

      <i
        :class="{ 'medical-history-section__icon--up': ui.isOpen }"
        class="icon icon-arrow-down medical-history-section__icon"
      />
    </header>

    <div
      v-if="ui.isOpen"
      ref="history-section-notes"
      class="medical-history-section__content"
    >
      <div class="history-notes__wrapper">
        <article
          v-for="(note, index) in notes"
          :key="`evaluation_note-${index}`"
          class="history-notes__note"
        >
          <p class="history-notes__note-text">
            {{ note.note }}
          </p>

          <footer class="history-notes__note-footer">
            <address class="history-notes___note-author">
              Criado em
              <time class="history-notes__note-pubdate">
                {{ note.created_at | TO_DATE_TIME }}.
              </time>
            </address>
          </footer>
        </article>
      </div>

      <div class="history-notes__wrapper">
        <textarea
          v-model="newNote"
          class="history-notes__text"
          placeholder="Escreva aqui a sua nota..."
        />

        <button
          class="btn btn-sm btn-primary history-notes__btn"
          text="Adicionar nota"
          @click="confirmAddNote"
        >
          Adicionar nota
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MedicalHistoryNotes',

  props: {
    appointmentId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      ui: {
        isLoading: false,
        isOpen: true
      },
      notes: [],
      newNote: null
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      this.fn_SHOW_PROGRESS()
      this.getNotes(this.appointmentId)
        .then((data) => (this.notes = data))
        .finally(this.fn_HIDE_PROGRESS)
    },

    async getNotes (appointmentId = null) {
      if (appointmentId) {
        const notesResponse = await this.$http
          .get(`/agenda/${appointmentId}/medical_note`, this.$store.getters.getAuthHeader)

        const notes = notesResponse.data.data || []

        return notes
      }

      return []
    },

    confirmAddNote () {
      if (this.newNote) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: `Tem certeza que deseja adicionar essa nota? Ela não poderá ser apagada ou editada depois.`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (!v) {
              this.$store.dispatch('setModalConfirm')
            } else {
              this.addNote()
            }
          },
          size: 'md',
          active: true
        })
      }
    },

    addNote () {
      this.fn_SHOW_PROGRESS()

      this.$http
        .post(
          `/agenda/${this.appointmentId}/medical_note`,
          { medical_note: { note: this.newNote } },
          this.$store.getters.getAuthHeader
        )
        .then((res) => {
          this.newNote = null
          this.$store.dispatch('setModalConfirm')
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Nota adicionada com sucesso.',
            size: 'md',
            active: true
          })

          this.init()
        })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(this.fn_HIDE_PROGRESS)
    }
  }
}
</script>
